import { GetterTree } from 'vuex';
import IRootState from '@/store/types/IRootState';
import HomeState from './types/IHomeState';

const getters: GetterTree<HomeState, IRootState> = {
  meta: (state) => state.meta,
  slider: (state) => state.slider,
  statistics: (state) => state.statistics,
  covid19: (state) => state.covid19,
};

export default getters;
